function isNumber(evt) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

function isDecimal(evt, obj) {
  var charCode = (evt.which) ? evt.which : event.keyCode
  var value = obj.value;
  var dotcontains = value.indexOf(".") != -1;
  if (dotcontains)
    if (charCode == 46) return false;
  if (charCode == 46) return true;
  if (charCode > 31 && (charCode < 48 || charCode > 57))
    return false;
  return true;
}

function onFocus(evt) {
  document.activeElement.select();
}

function onSendKey(v) {
  var e = new Event("keydown");
  e.key = v; // just enter the char you want to send 
  e.keyCode = e.key.charCodeAt(0);
  e.which = e.keyCode;
  e.altKey = false;
  e.ctrlKey = true;
  e.shiftKey = false;
  e.metaKey = false;
  e.bubbles = true;
  document.dispatchEvent(e);
}

function OnFocusOut(lastTabIndex) {
  var currentElement = $get(currentElementId); // ID set by OnFOcusIn
  var curIndex = currentElement.tabIndex; //get current elements tab index
  if (curIndex == lastTabIndex) {
    //if we are on the last tabindex, go back to the beginning
    curIndex = 0;
  }
  var tabbables = document.querySelectorAll("tabable"); //get all tabable elements
  for (var i = 0; i < tabbables.length; i++) {
    //loop through each element
    if (tabbables[i].tabIndex == curIndex + 1) {
      //check the tabindex to see if it's the element we want
      tabbables[i].focus(); //if it's the one we want, focus it and exit the loop
      break;
    }
  }
}

function fullscreen() {
  if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
    if (document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
}
